import { ClassData } from '@models/class-data';
import { Helpers } from '@utils/helpers';

export class EventPictureInfo {
  id: number;
  eventTemplateId: number;
  name?: string;
  description?: string;
  url?: string;
  linkUrl?: string;

  constructor(json: ClassData<EventPictureInfo>) {
    this.id = +json.id;
    this.eventTemplateId = +json.eventTemplateId;
    this.name = json.name;
    this.description = json.description;
    this.url = json.url;
    this.linkUrl = json.linkUrl;
  }

  getLinkUrl(): string {
    if (!this.linkUrl) {
      return '';
    }
    const websiteLink = this.linkUrl.trim();

    if (
      websiteLink === '' ||
      websiteLink.startsWith('https://') ||
      websiteLink.startsWith('http://')
    ) {
      return websiteLink;
    }

    return 'https://' + websiteLink;
  }

  isLinkValid(): boolean {
    return Helpers.isValidUrl(this.getLinkUrl());
  }
}
